// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__kw8fS","name":"ConsentHeader_name__2aJfA","birthday":"ConsentHeader_birthday__3xn59","skeleton":"ConsentHeader_skeleton__39KMe"};